import React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../store/actions'
import DaneOrganizacyjneStyle from '../../styles/DaneOrganizacyjneStyle'
import MainStyle from '../../styles/MainStyle'

import OkresSprawozdania from '../../components/DaneOrganizacyjne/OkresSprawozdania'
import CzasTrwaniaJednostki from '../../components/DaneOrganizacyjne/CzasTrwaniaJednostki'
import Uproszczenia from '../../components/DaneOrganizacyjne/Uproszczenia'
import WewnetrzneJednostki from '../../components/DaneOrganizacyjne/WewnetrzneJednostki'
import ZalozenieKontynuacji from '../../components/DaneOrganizacyjne/ZalozenieKontynuacji'
import PolaczenieSpolek from '../../components/DaneOrganizacyjne/PolaczenieSpolek'
class DaneOrganizacyjne extends React.Component {
  render() {
    const { sectionList, czyPodsumowanie } = this.props
    return (
      <MainStyle>
        <DaneOrganizacyjneStyle>
          {sectionList.map((data, index) => {
            switch (data.TypSekcji) {
              case 'OkresSprawozdania':
                return (
                  <OkresSprawozdania
                    key={index}
                    data={data.Dane}
                    dataWersjiOd={this.props.dataWersjiOd}
                    dataWersjiDo={this.props.dataWersjiDo}
                    poczatekOkresuOd={this.props.poczatekOkresuOd}
                    poczatekOkresuDo={this.props.poczatekOkresuDo}
                    poczatekOkresu={this.props.poczatekOkresu}
                    koniecOkresu={this.props.koniecOkresu}
                    dataSporzadzenia={this.props.dataSporzadzenia}
                    errors={this.props.validityErrors.filter(
                      (value) => value.TypSekcji === 'OkresSprawozdania',
                    )}
                    onSetSectionData={(name, value) =>
                      this.props.onSetSectionData(name, value, index)
                    }
                    onSetDates={this.props.onSetDates}
                  />
                )
              case 'CzasTrwania':
                return (
                  <CzasTrwaniaJednostki
                    key={index}
                    data={data.Dane}
                    errors={this.props.validityErrors.filter(
                      (value) => value.TypSekcji === 'CzasTrwania',
                    )}
                    onSetSectionData={(name, value) =>
                      this.props.onSetSectionData(name, value, index)
                    }
                  />
                )
              case 'Uproszczenia':
                return (
                  <Uproszczenia
                    key={index}
                    data={data.Dane}
                    KodSprawozdania={this.props.KodSprawozdania}
                    errors={this.props.validityErrors.filter(
                      (value) => value.TypSekcji === 'Uproszczenia',
                    )}
                    onSetSectionData={(name, value) =>
                      this.props.onSetSectionData(name, value, index)
                    }
                    czyPodsumowanie={czyPodsumowanie}
                  />
                )
              case 'WewnetrzneJednostki':
                return (
                  <WewnetrzneJednostki
                    title="WEWNĘTRZNE JEDNOSTKI ORGANIZACYJNE"
                    label="Sprawozdanie zawiera dane łączne wewnętrznych jednostek organizacyjnych sporządzających samodzielne sprawozdania finansowe"
                    key={index}
                    data={data.Dane}
                    onSetSectionData={(name, value) =>
                      this.props.onSetSectionData(name, value, index)
                    }
                  />
                )
              case 'KontynuacjaDzialalnosci':
                return (
                  <ZalozenieKontynuacji
                    title="ZAŁOŻENIE KONTYNUACJI DZIAŁALNOŚCI"
                    label1="Sprawozdanie sporządzone przy założeniu kontynuowania działalności gospodarczej w dającej się przewidzieć przyszłości"
                    label2="Istnieją okoliczności wskazujące na zagrożenie kontynuowania działalności gospodarczej"
                    key={index}
                    data={data.Dane}
                    errors={this.props.validityErrors.filter(
                      (value) => value.TypSekcji === 'KontynuacjaDzialalnosci',
                    )}
                    onSetSectionData={(name, value) =>
                      this.props.onSetSectionData(name, value, index)
                    }
                    czyPodsumowanie={czyPodsumowanie}
                  />
                )
              case 'PolaczenieSpolek':
                return (
                  <PolaczenieSpolek
                    key={index}
                    data={data.Dane}
                    errors={this.props.validityErrors.filter(
                      (value) => value.TypSekcji === 'PolaczenieSpolek',
                    )}
                    onSetSectionData={(name, value) =>
                      this.props.onSetSectionData(name, value, index)
                    }
                    czyPodsumowanie={czyPodsumowanie}
                  />
                )
              default:
                return null
            }
          })}
        </DaneOrganizacyjneStyle>
      </MainStyle>
    )
  }
}

const mapStateToProps = (state) => {  
  return {
    validityErrors: state.sprawozdanie.validityErrors
      ? state.sprawozdanie.validityErrors
      : [],
    KodSprawozdania: state.sprawozdanie.header.KodSprawozdania,
    dataWersjiOd: state.sprawozdanie.header.DataWersjiOd,
    dataWersjiDo: state.sprawozdanie.header.DataWersjiDo,
    poczatekOkresuOd: state.sprawozdanie.header.PoczatekOkresuOd,
    poczatekOkresuDo: state.sprawozdanie.header.PoczatekOkresuDo,
    dataSporzadzenia: state.sprawozdanie.dataSporzadzenia,
    poczatekOkresu: state.sprawozdanie.poczatekOkresu,
    koniecOkresu: state.sprawozdanie.koniecOkresu,
    czyPodsumowanie: state.sprawozdanie.czyPodsumowanie,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSetSectionData: (name, value, index) => {
      dispatch(actions.setSectionData(name, value, index))
    },
    onSetDates: (dateFrom, dateTo) =>
      dispatch(actions.setDates(dateFrom, dateTo)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DaneOrganizacyjne)
